import { createAction } from 'redux-actions';

const actions = {
  /**
   *  추천 상품 데이터 변경하기
   */
  SET_DATA: 'recommend/product/SET_DATA',
  setData: createAction('recommend/product/SET_DATA'),

  /**
   *  추천 상품 리스트 가져오기
   */
  GET_RECOMMEND_PRODUCT_LIST_REQUEST: 'recommend/product/GET_RECOMMEND_PRODUCT_LIST_REQUEST',
  GET_RECOMMEND_PRODUCT_LIST_SUCCESS: 'recommend/product/GET_RECOMMEND_PRODUCT_LIST_SUCCESS',
  getRecommendProductList: createAction('recommend/product/GET_RECOMMEND_PRODUCT_LIST_REQUEST'),

  /**
   *  추천 상품 상세 요청하기
   */
  GET_RECOMMEND_PRODUCT_DETAIL_REQUEST: 'recommend/product/GET_RECOMMEND_PRODUCT_DETAIL_REQUEST',
  GET_RECOMMEND_PRODUCT_DETAIL_SUCCESS: 'recommend/product/GET_RECOMMEND_PRODUCT_DETAIL_SUCCESS',
  getRecommendProductDetail: createAction('recommend/product/GET_RECOMMEND_PRODUCT_DETAIL_REQUEST'),

  /**
   * 추천 상품 상세 아이템 리스트 엑셀 다운로드
   */
  GET_RECOMMEND_PRODUCT_DETAIL_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/product/GET_RECOMMEND_PRODUCT_DETAIL_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendProductDetailItemListExcelDownload: createAction(
    'recommend/product/GET_RECOMMEND_PRODUCT_DETAIL_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  추천 상품 복사하기 전 필요한 데이터 가져오기
   */
  PREPARE_COPY_RECOMMEND_PRODUCT_REQUEST: 'recommend/product/PREPARE_COPY_RECOMMEND_PRODUCT_REQUEST',
  PREPARE_COPY_RECOMMEND_PRODUCT_SUCCESS: 'recommend/product/PREPARE_COPY_RECOMMEND_PRODUCT_SUCCESS',
  prepareCopyRecommendProduct: createAction('recommend/product/PREPARE_COPY_RECOMMEND_PRODUCT_REQUEST'),

  /**
   *  추천 상품 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_CREATE_RECOMMEND_PRODUCT_REQUEST: 'recommend/product/PREPARE_CREATE_RECOMMEND_PRODUCT_REQUEST',
  PREPARE_CREATE_RECOMMEND_PRODUCT_SUCCESS: 'recommend/product/PREPARE_CREATE_RECOMMEND_PRODUCT_SUCCESS',
  prepareCreateRecommendProduct: createAction('recommend/product/PREPARE_CREATE_RECOMMEND_PRODUCT_REQUEST'),

  /**
   *  추천 상품에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_PRODUCT_ITEM_REQUEST: 'recommend/product/GET_RECOMMEND_PRODUCT_ITEM_REQUEST',
  GET_RECOMMEND_PRODUCT_ITEM_SUCCESS: 'recommend/product/GET_RECOMMEND_PRODUCT_ITEM_SUCCESS',
  getRecommendProductItemList: createAction('recommend/product/GET_RECOMMEND_PRODUCT_ITEM_REQUEST'),

  /**
   *  추천 상품 등록/복사하기
   */
  CREATE_RECOMMEND_PRODUCT_REQUEST: 'recommend/PRODUCT/CREATE_RECOMMEND_PRODUCT_REQUEST',
  createRecommendProduct: createAction('recommend/PRODUCT/CREATE_RECOMMEND_PRODUCT_REQUEST'),

  /**
   *  추천 상품 등록하기(엑셀)
   */
  CREATE_RECOMMEND_PRODUCT_BY_EXCEL_REQUEST: 'recommend/PRODUCT/CREATE_RECOMMEND_PRODUCT_BY_EXCEL_REQUEST',
  createRecommendProductByExcel: createAction('recommend/PRODUCT/CREATE_RECOMMEND_PRODUCT_BY_EXCEL_REQUEST'),

  /**
   *  전체 상품 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/PRODUCT/GET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendProductItemListExcelDownload: createAction(
    'recommend/PRODUCT/GET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  선택된 상품 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/PRODUCT/GET_SELECTED_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedRecommendProductItemListExcelDownload: createAction(
    'recommend/PRODUCT/GET_SELECTED_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  상품 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'recommend/PRODUCT/SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_SUCCESS:
    'recommend/PRODUCT/SET_RECOMMEND_PRODUCT_ITEM_EXCEL_UPLOAD_SUCCESS',
  setRecommendProductItemListExcelUpload: createAction(
    'recommend/PRODUCT/SET_RECOMMEND_PRODUCT_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),
};

export default actions;
